export default function PageJsonLd() {
  const serviceSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Тренинг по холодным звонкам',
    provider: {
      '@type': 'Person',
      name: 'Алексей Сивко',
      description: 'Бизнес-тренер с более чем 18-летним опытом в продажах и переговорах',
      url: 'https://sivko.by/',
    },
    description: 'Корпоративный тренинг по холодным звонкам для отделов продаж. Практическое обучение с диагностикой, прослушиванием реальных звонков, отработкой навыков и сопровождением внедрения.',
    areaServed: ['Беларусь', 'Россия', 'Казахстан', 'Израиль'],
    serviceType: 'Корпоративное обучение холодным звонкам',
    offers: {
      '@type': 'Offer',
      availability: 'https://schema.org/InStock',
      category: 'Корпоративный тренинг',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'Вы как тренер сами звоните на тренинге в качестве примера?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, я регулярно делаю живые звонки на тренинге. Это ключевой элемент обучения: участники видят, как работает методика в реальном разговоре, слышат живую реакцию собеседника, наблюдают за интонацией и темпом. После звонка мы вместе разбираем: что сработало, какие приёмы использовались, как реагировал клиент. Никакой теории — только реальная практика перед глазами группы.',
        },
      },
      {
        '@type': 'Question',
        name: 'Почему холодные звонки до сих пор работают?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Холодные звонки остаются одним из самых эффективных каналов прямых продаж B2B, потому что позволяют быстро установить личный контакт, выявить потребность и договориться о встрече. При правильном подходе — без давления и агрессивных скриптов — холодный звонок превращается в профессиональную деловую коммуникацию, которая открывает возможности для долгосрочного сотрудничества.',
        },
      },
      {
        '@type': 'Question',
        name: 'Подходит ли программа для B2B?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, программа специально разработана для B2B-продаж. Мы учим выходить на ЛПР в крупных и средних компаниях, проходить секретарей, формулировать ценность для бизнес-аудитории и назначать встречи с лицами, принимающими решения. Все кейсы и практические задания строятся на реальных B2B-сценариях.',
        },
      },
      {
        '@type': 'Question',
        name: 'Можно ли обучать опытных менеджеров?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, опытные менеджеры часто получают наибольшую пользу от обучения, потому что у них уже есть база реальных ситуаций для разбора. Мы выявляем скрытые неэффективные привычки, усиливаем сильные стороны и помогаем выйти на новый уровень конверсии. Программа адаптируется под уровень каждого участника.',
        },
      },
      {
        '@type': 'Question',
        name: 'Используются ли реальные звонки сотрудников?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, это основа программы. Мы прослушиваем реальные записи звонков ваших менеджеров, анализируем их и разбираем на тренинге. Участники работают со своими настоящими клиентами и сценариями — это повышает вовлечённость и позволяет сразу применить новые навыки в привычных ситуациях.',
        },
      },
      {
        '@type': 'Question',
        name: 'Можно ли адаптировать программу под нашу отрасль?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, каждая программа адаптируется под конкретную отрасль, продукт и рынок компании. Мы используем реальные кейсы, возражения и сценарии из вашей практики. Никаких универсальных скриптов — только то, что работает в вашем сегменте и с вашими клиентами.',
        },
      },
      {
        '@type': 'Question',
        name: 'Есть ли сопровождение после тренинга?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, сопровождение — ключевой элемент программы. После основного тренинга мы продолжаем работу: разбираем новые звонки, корректируем стратегию, поддерживаем в чате, помогаем внедрять регламенты. Именно сопровождение обеспечивает закрепление навыков и устойчивый рост показателей.',
        },
      },
      {
        '@type': 'Question',
        name: 'Через сколько появляются первые результаты?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Первые изменения в поведении менеджеров видны уже после первого тренингового дня. Измеримые бизнес-результаты — рост конверсии, увеличение количества назначенных встреч, сокращение цикла сделки — обычно проявляются через 2–4 недели после обучения при условии активного внедрения и сопровождения.',
        },
      },
      {
        '@type': 'Question',
        name: 'Можно ли провести обучение онлайн?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, тренинг по холодным звонкам доступен в онлайн-формате: живые сессии с отработкой звонков через видеосвязь, ролевые переговоры, разбор реальных кейсов и записей разговоров. Онлайн-формат полностью сохраняет практическую направленность и эффективность обучения.',
        },
      },
    ],
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Главная',
        item: { '@id': 'https://business-training.by/', name: 'Главная' },
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Продажи и переговоры',
        item: { '@id': 'https://business-training.by/prodazhi-i-peregovory/trening-po-prodazham', name: 'Продажи и переговоры' },
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: 'Тренинг по холодным звонкам',
        item: { '@id': 'https://business-training.by/prodazhi-i-peregovory/trening-po-holodnym-zvonkam', name: 'Тренинг по холодным звонкам' },
      },
    ],
  };

  const personSchema = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Алексей Сивко',
    jobTitle: 'Бизнес-тренер, эксперт по продажам и переговорам',
    url: 'https://sivko.by/',
    description: 'Бизнес-тренер с 18+ лет опыта в продажах и переговорах. Провёл более 450 корпоративных тренингов для 4500+ участников из Беларуси, России, Казахстана и Израиля.',
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(serviceSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(personSchema) }} />
    </>
  );
}